import styled from "styled-components";

const Link = styled.a`
  text-decoration: none !important;
  color: #222;
  background-color: transparent;
  cursor:pointer;

  &:hover {
    color: #222;
  }
`;
export default Link;
